// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymodesFooter_container__2YwrW","title":"PaymodesFooter_title__2oIqu","images":"PaymodesFooter_images__1fYYa"};